import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import arrow_left from "../../images/arrow-left.png";
import { RootState } from '../store';
import { setwizardPageNumber, setwizardPageName } from '../EntityAccountReducer';
import { useDispatch, useSelector } from 'react-redux';

function BackButton(props: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);
  const pageName = useSelector((state: RootState) => state.entityAccount.pageName);
  const theme = useSelector((state: RootState) => state.theme.theme);

  const handleBack = () => {
    if (page === 6) {
      const subPageFlow = [
        "businessInfo",
        "businessPhysicalAddress",
        "accountUse",
        "successBusinessInfo",
        "authorizedRep",
        "beneficialOwners",
        "directors",
        "successRelatedParties",
        "uploaddoc",
        "certification"
      ];
      
      const currentIndex = subPageFlow.indexOf(pageName);
      if (currentIndex > 0) {
        const prevSubPage = subPageFlow[currentIndex - 1];
        dispatch(setwizardPageName(prevSubPage));
        localStorage.setItem('pageName', prevSubPage);
        return;
      }
    }

    if ((page - 1) === 0) {
      navigate("/");
      window.location.reload();
    }
    dispatch(setwizardPageNumber(page - 1));
    localStorage.setItem('pageNumber', `${page - 1}`);
  };

  return (
    <span
      onClick={handleBack}
      role="button"
      className={`back-button ${theme === "dark" ? "back-button-dark" : "back-button-light"}`}
    >
      <img
        src={arrow_left}
        width={23}
        alt="Back Arrow"
        className={`arrow-icon ${theme === "dark" ? "arrow-icon-dark" : "arrow-icon-light"}`}
      />
      <span className={`fw-bold small ms-2 ${theme === "dark" ? "text-light" : "text-dark"}`}>
        {t('common.back')}
      </span>
    </span>
  );
}

export default BackButton;
